var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.951,
    height: 27.951,
    viewBox: "0 0 27.951 27.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.879,
    y1: 0.847,
    x2: 0.179,
    y2: 0.291,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle",
    "data-name": "Icon feather-message-circle",
    d: "M17.383,2.75H18.1l.088,0A13.261,13.261,0,0,1,30.7,15.263q0,.044,0,.088v.687A13.295,13.295,0,0,1,17.414,29.327h-.031a13.2,13.2,0,0,1-5.3-1.116L4.861,30.619A1.6,1.6,0,0,1,2.832,28.59l2.409-7.226A13.294,13.294,0,0,1,17.383,2.75Zm.672,3.208h-.672a9.964,9.964,0,0,0-4.471,1.065l-.006,0A10.065,10.065,0,0,0,8.4,20.539a1.6,1.6,0,0,1,.09,1.23l-1.6,4.793,4.793-1.6a1.6,1.6,0,0,1,1.23.09,9.964,9.964,0,0,0,4.471,1.065h.026a10.028,10.028,0,0,0,9.017-5.574l0-.006a9.963,9.963,0,0,0,1.065-4.5V15.4A10.041,10.041,0,0,0,18.055,5.958Z",
    transform: "translate(-2.75 -2.75)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.cbc57a20b5ad72f92e499c7d4967cbc8.svg";
export { ForwardRef as ReactComponent };